import 'app.css'
import { Provider } from 'react-redux'
import { ThemeProvider } from 'styled-components'
import { theme, GlobalStyle } from 'common/styles'
import { PersistGate } from 'redux-persist/integration/react'
import { persistor, store } from 'common/store/store'
import Toaster from 'common/components/organisms/Toaster'
import WebRoutes from './features/routes'
import SplashPopup from 'common/components/organisms/SplashPopup'
import { useEffect, useState } from 'react'
import { TemplateContext } from 'common/contexts/TemplateContext'
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from 'features/auth/SSO/config'
import Loader from 'features/client/components/organisms/Loader'

const msalInstance = new PublicClientApplication(msalConfig);

const App = () => {
  const [templateName, setTemplateName] = useState('home')
  const [pageTitle, setPageTitle] = useState('My account')

  const handleSetTemplateName = (newTemplate: any) => {
    setTemplateName(newTemplate)
  }

  const value = {
    templateName, setTemplateName: handleSetTemplateName, setPageTitle, pageTitle,
  }

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <Toaster>
            <MsalProvider instance={msalInstance}>
              <SplashPopup>
                <TemplateContext.Provider {...{ value }}>
                  <Loader>
                    <WebRoutes />
                  </Loader>
                </TemplateContext.Provider>
              </SplashPopup>
            </MsalProvider>
          </Toaster>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
};

export default App
